export default "__VITE_ASSET__D7mfc$0W__"